document.addEventListener('DOMContentLoaded', () => {
   const button = document.querySelector('.wcl-scroll-to-top');

   if (!button) return;

   window.addEventListener('scroll', () => {
      button.classList.toggle('is-visible', window.scrollY > 300);
   });

   button.addEventListener('click', () => {
      window.scrollTo({
         top: 0,
         behavior: 'smooth',
      });
   });
});